<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />

    <div class="mb-2">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <router-link to="/prestador">Prestador</router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link :to="'/prestador_elempres/' + datoElemPres.idPrestador">
              {{ datoElemPres.prestadorRazonSocial || 'Detalle' }}
            </router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            Código: {{ datoElemPres.codigo }}
          </li>
        </ol>
      </nav>
    </div>
    <hr />

    <div class="card mb-4 shadow-sm">
      <div class="card-body">
        <form>
          <div class="row mb-3">
            <div class="col-md-1"><label class="form-label fw-bold">Código</label></div>
            <div class="col-md-5">
              <input type="text" class="form-control-plaintext" :value="datoElemPres.codigo" readonly style="text-transform: uppercase" />
            </div>
            <div class="col-md-1"><label class="form-label fw-bold">ID</label></div>
            <div class="col-md-5">
              <input type="text" class="form-control-plaintext" :value="datoElemPres.idElemPres" readonly />
            </div>
          </div>
          <div class="row">
            <div class="col-md-1"><label class="form-label fw-bold">Nombre</label></div>
            <div class="col-md-11">
              <input type="text" class="form-control-plaintext" :value="datoElemPres.nombre" readonly style="text-transform: uppercase" />
            </div>
          </div>
        </form>
      </div>
    </div>

    <h5 class="mb-3">
      <span class="material-icons align-middle me-1" style="font-size:20px">check</span>
      Equivalencias de Elementos
    </h5>

    <DataTable
      :data="elemequis"
      :columns="columnasDet"
      idField="idElemEqui"
      mensajeVacio="No hay equivalencias registradas."
      :mostrarBotonNuevo="true"
      :mostrarEditar="true"
      :mostrarVer="false"
      :mostrarEliminar="false"
      @refresh="getDataTodos"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idElemEqui)"
      @delete="row => deleteElemEqui(row.idElemEqui)"
    >
      <template #acciones-extra>
        <div class="col-auto d-flex align-items-center gap-1">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="nombreBusqueda"
            placeholder="Buscar en prestador..."
            style="width:250px; text-transform:uppercase"
            @keyup.enter="getDataNombre"
          />
          <button class="btn btn-outline-primary btn-sm" @click="getDataNombre">
            <span class="material-icons" style="font-size:16px">search</span>
          </button>
        </div>
      </template>
    </DataTable>

    <div class="modal fade" id="ventanaModal" tabindex="-1" aria-hidden="true" v-if="modalWindow">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h5 class="modal-title">
              <span class="material-icons align-middle me-1">swap_horiz</span> {{ titulo }}
            </h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form>
              <div class="mb-3">
                <label class="form-label fw-bold">Seleccionar Elemento Estándar</label>
                <select class="form-select" v-model="datoElemEqui.idElemento">
                  <option disabled value="">Seleccione un elemento...</option>
                  <option v-for="elem in elementos" :key="elem.idElemento" :value="elem.idElemento">
                    {{ elem.clasElemNombre }} | {{ elem.codigo }} - {{ elem.nombre }}
                  </option>
                </select>
              </div>
              </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click.prevent="guardarElemEqui" v-if="btnCrear_det">
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span> Guardar
            </button>
            <button type="button" class="btn btn-warning" @click.prevent="guardarEditElemEqui" v-if="btnEditar_det">
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span> Actualizar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import DataTable from "@/components/DataTable.vue";
import api from "@/services/api";
import Swal from "sweetalert2";
import * as $ from "jquery";

export default {
  name: "ElemPresEquivalenciaForm",
  components: { Layout, Footer, DataTable },
  data() {
    return {
      p_idElemPres: "",
      datoElemPres: {},
      
      elemequis: [],
      datoElemEqui: {},
      elementos: [], // LOV
      nombreBusqueda: "",
      titulo: "",
      btnCrear_det: false,
      btnEditar_det: false,
      modalWindow: true,
    };
  },
  computed: {
    columnasDet() {
      return [
        { label: "Cód. Estándar", field: "elementoCodigo" },
        { label: "Nombre Estándar", field: "elementoNombre" },
        { label: "Cód. Prestador", field: "elemPresCodigo" },
        { label: "Nombre Prestador", field: "elemPresNombre" },
        { label: "Estado", field: "estado" },
      ];
    },
  },
  mounted() {
    this.p_idElemPres = this.$route.params.p_idelempres;
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    
    this.cargarMaster();
    this.getDataTodos();
    this.fetchElementos();
  },
  methods: {
    // ── Master ────────────────────────────────────────────────
    async cargarMaster() {
      try {
        const resp = await api.get("/vwelempress/" + this.p_idElemPres);
        this.datoElemPres = resp.data;
      } catch (e) { console.error("Error Master:", e); }
    },

    // ── Detail Data ───────────────────────────────────────────
    async getDataTodos() {
      try {
        const r = await api.get("/vwelemequis/idelempres/" + this.p_idElemPres);
        this.elemequis = Array.isArray(r.data) ? r.data : [];
      } catch (e) { console.error("Error Detail:", e); }
    },

    async getDataNombre() {
      if (!this.nombreBusqueda.trim()) { this.getDataTodos(); return; }
      try {
        const r = await api.get("/vwelemequis/nombre/" + this.nombreBusqueda);
        this.elemequis = r.data.filter(i => i.idElemPres == this.p_idElemPres);
      } catch (e) { console.error("Error Search:", e); }
    },

    async fetchElementos() {
      try {
        const r = await api.get("/vwelementos");
        this.elementos = r.data;
      } catch (e) { console.error("Error LOV:", e); }
    },

    // ── CRUD ──────────────────────────────────────────────────
    async guardarElemEqui() {
      try {
        this.datoElemEqui.idElemPres = this.p_idElemPres;
        await api.post("/elemequis", this.datoElemEqui);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "Guardado", text: "Equivalencia registrada." });
        this.getDataTodos();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo guardar." });
      }
    },

    async guardarEditElemEqui() {
      try {
        await api.post("/elemequis", this.datoElemEqui);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "Actualizado", text: "Registro actualizado." });
        this.getDataTodos();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo actualizar." });
      }
    },

    async deleteElemEqui(id) {
      const confirm = await Swal.fire({
        title: "¿Eliminar equivalencia?",
        text: "Se borrará el vínculo con el elemento estándar.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Sí, eliminar"
      });
      if (!confirm.isConfirmed) return;
      try {
        await api.delete("/elemequis/" + id);
        this.getDataTodos();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar." });
      }
    },

    // ── Modales ───────────────────────────────────────────────
    abrirModalCrear() {
      this.datoElemEqui = { idElemPres: this.p_idElemPres, idElemento: "" };
      this.titulo = "Crear Equivalencia";
      this.btnCrear_det = true;
      this.btnEditar_det = false;
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    async abrirModalEditar(id) {
      this.titulo = "Editar Equivalencia";
      this.btnCrear_det = false;
      this.btnEditar_det = true;
      try {
        const resp = await api.get("/vwelemequis/" + id);
        this.datoElemEqui = resp.data;
        this.$nextTick(() => $("#ventanaModal").modal("show"));
      } catch (e) { console.error("Error cargar edit:", e); }
    }
  }
};
</script>	